import Keycloak from 'keycloak-js';
import {loginSuccess} from '../../session/actions/actions';

const keycloakInfo = {
  'realm': 'Toyota',
  'clientId': 'tems-web',
  'url': process.env.REP_AUTH_URL,
};

export const kc = new Keycloak(keycloakInfo);

export default class keycloakConnector {
  static init(store, persistedStore, renderApp) {
    kc.init({'onLoad': 'check-sso', 'checkLoginIframe': false}).then((authenticated) => {
      if (authenticated) {
        store.dispatch(loginSuccess(kc));
        renderApp();
      } else {
        const path = window.location;
        const baseUrl = `${path.protocol}//${path.host}`;
        persistedStore.purge().then(() => {
          kc.login({'redirectUri': `${baseUrl}/cargando`});
        });
      }
    });
  }
  
  static logout(reduxStore) {
    reduxStore.purge().then(() => {
      kc.logout();
    });
  }
}
